import IconSparkleGradient from '@creditflowresearch/uilib/Icon/IconSparkleGradient';
import styles from './askAiChat.module.scss';

interface IProcessingIndicatorProps {
  label?: string,
  progress?: number,
}

const ProcessingIndicator = ({ label, progress }: IProcessingIndicatorProps) => (
  <div className={ styles.processing } data-test="askAiChatProcessing">
    <IconSparkleGradient className={ styles.processingIcon } />
    <div className={ styles.processingLines }>
      <span className={ styles.processingCurrent }>
        Thinking...{ progress !== undefined && ` (${ progress }%)` }
      </span>
      <span key={ label } className={ styles.processingLabel }>
        { label }
      </span>
    </div>
  </div>
);

export default ProcessingIndicator;
